/* ===== menüleri açma ===== */
(function () {
  const DURATION = 250;       // ms
  const EASING   = 'ease';    // cubic-bezier de kullanabilirsin

  function expand(li, submenu) {
    // Açılışa hazırlan
    submenu.style.overflow   = 'hidden';
    submenu.style.transition = `height ${DURATION}ms ${EASING}`;

    // Önce görünür yap ki ölçebilelim
    const prevDisplay = submenu.style.display;
    submenu.style.display = 'block';

    // Başlangıç yüksekliği 0
    submenu.style.height = '0px';

    // Reflow (ölçüm tetikle)
    // eslint-disable-next-line no-unused-expressions
    submenu.offsetHeight;

    // Hedef yüksekliğe animasyon
    const target = submenu.scrollHeight;
    submenu.style.height = target + 'px';

    // Animasyon bitince auto'ya dön (içerik değişse bozulmasın)
    const onEnd = (ev) => {
      if (ev.propertyName !== 'height') return;
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);

    li.classList.add('is--opend');
  }

  function collapse(li, submenu) {
    submenu.style.overflow   = 'hidden';
    submenu.style.transition = `height ${DURATION}ms ${EASING}`;

    // Mevcut yüksekliği sabitle
    const current = submenu.scrollHeight;
    submenu.style.height = current + 'px';

    // Reflow
    // eslint-disable-next-line no-unused-expressions
    submenu.offsetHeight;

    // 0'a animasyon
    submenu.style.height = '0px';

    const onEnd = (ev) => {
      if (ev.propertyName !== 'height') return;
      submenu.style.display = 'none';
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);

    li.classList.remove('is--opend');
  }

  document.addEventListener('click', function (e) {
    const a = e.target.closest(
      '.t4s-item-level-0.t4s-menu-item-has-children > a'
    );
    if (!a) return;

    const plusIcon = a.querySelector('.t4s-mb-nav__icon');
    if (plusIcon && (e.target === plusIcon || plusIcon.contains(e.target))) {
      return; // temanın kendi + davranışını bozma
    }

    e.preventDefault();
    e.stopPropagation();

    const li = a.parentElement;
    const submenu = li.querySelector(':scope > .t4s-sub-menu');
    if (!submenu) return;

    const isOpen = li.classList.contains('is--opend');

    // Akordeon: aynı seviyedeki diğer açıkları animasyonla kapat
    const siblings = li.parentElement ? li.parentElement.children : [];
    for (const sib of siblings) {
      if (sib !== li && sib.classList && sib.classList.contains('is--opend')) {
        const sm = sib.querySelector(':scope > .t4s-sub-menu');
        if (sm) collapse(sib, sm);
      }
    }

    // Aç/Kapa animasyonlu
    if (isOpen) {
      collapse(li, submenu);
    } else {
      expand(li, submenu);
    }
  });

  // UX ipucu
  const style = document.createElement('style');
  style.textContent = `
    .t4s-item-level-0.t4s-menu-item-has-children > a { cursor: pointer; }
    @media (prefers-reduced-motion: reduce) {
      .t4s-sub-menu { transition: none !important; }
    }
  `;
  document.head.appendChild(style);
})();

/* ===== Collection thumbnail nav — Flickity söküp native scroll + alta kayan çubuk + seçiliye ortala ===== */
(function () {
  // Yol kisiti KALDIRILDI (22 Tem 2026): serit artik ana sayfada da var
  // (TLSK Premium Homepage > "Collection thumbnails" blogu). setup() zaten
  // .t4s-top-collections + .t4s-thumb-cl bulamazsa hicbir sey yapmaz, no-op'tur.
  // Tema flickity'sinin thumbnail şeridine hiç dokunmamasını sağla (parse anında, deferred theme.min.js'ten önce) — flickity↔native yarışını ve aralıklı boşluk/genişlik kaymasını engeller
  function killFlickity() {
    document.querySelectorAll('.t4s-top-collections .t4s-top-list-collections[data-flickityt4s-js]').forEach(function (l) {
      if (!l.querySelector('.t4s-thumb-cl')) return;
      l.removeAttribute('data-flickityt4s-js');
      l.classList.remove('flickityt4s', 'flickityt4s-enabled');
      l.classList.add('t4s-cl-native');
    });
  }
  killFlickity();
  function unflick(list) {
    var vp = list.querySelector(':scope > .flickityt4s-viewport, :scope > .flickity-viewport');
    if (vp) {
      var slider = vp.querySelector(':scope > .flickityt4s-slider, :scope > .flickity-slider') || vp;
      Array.prototype.slice.call(slider.children).forEach(function (c) {
        c.style.position = ''; c.style.left = ''; c.style.right = ''; c.style.transform = ''; c.style.margin = '';
        list.appendChild(c);
      });
      vp.remove();
    }
    Array.prototype.slice.call(list.querySelectorAll(':scope > .flickityt4s-button, :scope > .flickity-button')).forEach(function (b) { b.remove(); });
    list.classList.remove('flickityt4s-enabled', 'flickityt4s', 'flickity-enabled');
    list.removeAttribute('data-flickityt4s-js');
    list.style.height = '';
    list.classList.add('t4s-cl-native');
  }
  function setup(wrap) {
    var list = wrap.querySelector('.t4s-top-list-collections');
    if (!list || !wrap.querySelector('.t4s-thumb-cl') || list.__clInit) return;
    list.__clInit = true;
    try { unflick(list); } catch (e) {}
    list.style.overscrollBehaviorX = 'contain';
    var _cells = list.querySelectorAll('.t4s-cat-item');
    for (var _ci = 0; _ci < _cells.length; _ci++) { _cells[_ci].style.setProperty('--i', _ci); }
    var _allc = list.querySelectorAll('.t4s-cat-item'), _curI = 0;
    for (var _q = 0; _q < _allc.length; _q++) { if (_allc[_q].classList.contains('t4s-current-cat')) { _curI = _q; break; } }
    for (var _t = Math.max(0, _curI - 3); _t < Math.min(_allc.length, _curI + 4); _t++) {
      var _im = _allc[_t].querySelector('.t4s-thumb-cl img[data-src]'); if (!_im) continue;
      var _ds = _im.getAttribute('data-src');
      var _url = /[?&]width=\d+/.test(_ds) ? _ds.replace(/([?&])width=\d+/, '$1width=320') : _ds + (_ds.indexOf('?') > -1 ? '&' : '?') + 'width=320';
      _im.removeAttribute('data-sizes'); _im.removeAttribute('data-src'); _im.src = _url; _im.classList.add('lazyloadt4sed');
    }
    void list.offsetWidth; list.classList.add('t4s-cl-anim');

    var bar = document.createElement('div'); bar.className = 't4s-cl-scrollbar';
    var thumb = document.createElement('div'); thumb.className = 't4s-cl-scrollbar__thumb';
    bar.appendChild(thumb); wrap.appendChild(bar);

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      if (max <= 2) { bar.style.visibility = 'hidden'; bar.style.pointerEvents = 'none'; return; }
      bar.style.visibility = 'visible'; bar.style.pointerEvents = '';
      thumb.style.width = ((list.scrollLeft / max) * 100) + '%';
      bar.classList.toggle('t4s-cl-bar-active', list.scrollLeft > 1);
    }
    function seek(x) {
      var r = bar.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (x - r.left) / r.width));
      list.scrollLeft = p * (list.scrollWidth - list.clientWidth);
    }
    var drag = false;
    bar.addEventListener('pointerdown', function (e) { drag = true; seek(e.clientX); try { bar.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); });
    bar.addEventListener('pointermove', function (e) { if (drag) seek(e.clientX); });
    bar.addEventListener('pointerup', function () { drag = false; });
    bar.addEventListener('pointercancel', function () { drag = false; });
    list.addEventListener('scroll', update, { passive: true });
    list.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var max = list.scrollWidth - list.clientWidth;
      if (max <= 0) return;
      var next = list.scrollLeft + e.deltaY;
      if (next < 0 || next > max) return;
      list.scrollLeft = next; e.preventDefault();
    }, { passive: false });
    var _dn=false,_sx=0,_ss=0,_mv=false;
    list.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      _dn=true; _mv=false; _sx=e.clientX; _ss=list.scrollLeft;
    });
    document.addEventListener('mousemove', function (e) {
      if (!_dn) return;
      var dx = e.clientX - _sx;
      if (Math.abs(dx) > 4) _mv = true;
      if (_mv) { list.scrollLeft = _ss - dx; list.classList.add('t4s-cl-grabbing'); e.preventDefault(); }
    });
    document.addEventListener('mouseup', function () { if (_dn) { _dn=false; list.classList.remove('t4s-cl-grabbing'); } });
    list.addEventListener('click', function (e) { if (_mv) { e.preventDefault(); e.stopPropagation(); _mv=false; } }, true);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    window.addEventListener('resize', update);

    var cur = list.querySelector('.t4s-current-cat');
    var _allItemsD = list.querySelectorAll('.t4s-cat-item'), _curIdxD = 0;
    for (var _qiD = 0; _qiD < _allItemsD.length; _qiD++) { if (_allItemsD[_qiD].classList.contains('t4s-current-cat')) { _curIdxD = _qiD; break; } }
    var _syncFitD = function() { list.classList.toggle('t4s-cl-startfit', _curIdxD === 0 && list.scrollLeft <= 4); };
    requestAnimationFrame(function () {
      if (cur) { var _pb = list.style.scrollBehavior; list.style.scrollBehavior = 'auto'; list.scrollLeft = Math.max(0, cur.offsetLeft - (list.clientWidth - cur.offsetWidth) / 2); list.style.scrollBehavior = _pb; }
      update();
      _syncFitD();
    });
    list.addEventListener('scroll', _syncFitD, { passive: true });

    if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
      list.classList.add('t4s-cl-hasfocus');

      if (!window.__clFocusCSS) {
        window.__clFocusCSS = true;
        var _st = document.createElement('style');
        _st.textContent =
          '@media (hover: none){' +
          '.t4s-top-collections:has(.t4s-thumb-cl) .t4s-top-list-collections.t4s-cl-hasfocus .t4s-cat-item{' +
            'opacity:calc(.36 + .64*var(--foc,1)) !important;transition:none;}' +
          '.t4s-top-collections:has(.t4s-thumb-cl) .t4s-top-list-collections.t4s-cl-startfit{' +
            'padding-inline-start:16px;' +
            '-webkit-mask-image:linear-gradient(to right,#000 0,#000 calc(100% - 12px),transparent 100%);' +
            'mask-image:linear-gradient(to right,#000 0,#000 calc(100% - 12px),transparent 100%);}' +
          // mobilde yavaş yükleme efektini kaldır: giriş cascade'i ve görsel fade kapalı (anında görünsün)
          '.t4s-top-collections:has(.t4s-thumb-cl) .t4s-top-list-collections.t4s-cl-anim .t4s-cat-item{animation:none !important;}' +
          '.t4s-top-collections:has(.t4s-thumb-cl) .t4s-thumb-cl img{opacity:1 !important;transition:none !important;}' +
          '}';
        document.head.appendChild(_st);
      }

      var _its0 = list.querySelectorAll('.t4s-cat-item'), _curIndex = 0;
      for (var _ci2 = 0; _ci2 < _its0.length; _ci2++) {
        if (_its0[_ci2].classList.contains('t4s-current-cat')) { _curIndex = _ci2; break; }
      }

      var setFoc = function (active) {
        var its = list.querySelectorAll('.t4s-cat-item'), n = its.length;
        for (var i = 0; i < n; i++) {
          var d = Math.abs(i - active), f = d < 1.5 ? Math.max(0, 1 - d / 1.5) : 0;
          its[i].style.setProperty('--foc', f.toFixed(3));
        }
      };

      var syncStartfit = function () {
        list.classList.toggle('t4s-cl-startfit', _curIndex === 0 && list.scrollLeft <= 4);
      };

      setFoc(_curIndex);
      syncStartfit();

      var focByScroll = function () {
        var its = list.querySelectorAll('.t4s-cat-item'), n = its.length;
        if (!n) return;
        var cw = list.clientWidth, max = list.scrollWidth - cw, sl = list.scrollLeft;
        var focal = sl + cw / 2, active = 0;
        var c0 = its[0].offsetLeft + its[0].offsetWidth / 2;
        var cN = its[n - 1].offsetLeft + its[n - 1].offsetWidth / 2;
        if (focal <= c0) active = 0;
        else if (focal >= cN) active = n - 1;
        else for (var i = 0; i < n - 1; i++) {
          var a = its[i].offsetLeft + its[i].offsetWidth / 2;
          var b = its[i + 1].offsetLeft + its[i + 1].offsetWidth / 2;
          if (focal >= a && focal <= b) { active = i + (focal - a) / (b - a); break; }
        }
        var leftPin = max > 0 ? Math.max(0, 1 - sl / (cw * 0.5)) : 1;
        var rightPin = max > 0 ? Math.max(0, 1 - (max - sl) / (cw * 0.5)) : 1;
        active = active * (1 - leftPin);
        active = active * (1 - rightPin) + (n - 1) * rightPin;
        setFoc(active);
        syncStartfit();
      };

      var _fr, _interacted = false;
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        list.addEventListener(ev, function () { _interacted = true; }, { passive: true });
      });
      list.addEventListener('scroll', function () {
        if (_fr) cancelAnimationFrame(_fr);
        _fr = requestAnimationFrame(_interacted ? focByScroll : function () { setFoc(_curIndex); syncStartfit(); });
      }, { passive: true });
      window.addEventListener('resize', function () { _interacted ? focByScroll() : setFoc(_curIndex); });
      setTimeout(function () { setFoc(_curIndex); syncStartfit(); }, 400);
    }
  }
  function init() { killFlickity(); document.querySelectorAll('.t4s-top-collections').forEach(setup); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 400);
  setTimeout(init, 1200);
  // TLSK 2026-07-23: window.load'daki İKİNCİ ortalama KALDIRILDI. Şerit setup() içinde (rAF) zaten
  // ortalanıyor; buradaki tekrar, görseller geç geldiğinde ~3sn sonra tetiklenip kullanıcının gözü
  // önünde şeridi kaydırıyordu ("itemler önce saçma yerde, sayfa yüklenince yerine oturuyor").
  // Item genişlikleri CSS'te sabit (mobil 72px / masaüstü 104px) olduğundan görseller yüklendiğinde
  // offsetLeft DEĞİŞMEZ → ikinci ortalamaya gerek yok. Sadece anim sınıfı güvenlik ağı olarak kalır.
  window.addEventListener('load', function () {
    setTimeout(function () {
      var _ls = document.querySelectorAll('.t4s-top-list-collections.t4s-cl-native');
      for (var _li = 0; _li < _ls.length; _li++) {
        var _l = _ls[_li];
        if (!_l.classList.contains('t4s-cl-anim')) { void _l.offsetWidth; _l.classList.add('t4s-cl-anim'); }
      }
    }, 150);
  });
})();

// live chat  (Chizy AI chatbot — Shopify Inbox'in yerine gecti)

(function () {
  // Chizy launcher baloncugu (sag-alt) KAPALIYKEN gizli: chat sadece "Live Chat"
  // yazilarindan (contact + mobil menu + top bar, [data-open-chat]) acilir (eski
  // Shopify Inbox kurgusu gibi). Gizleme TOGGLE'lidir: chat ACIKKEN gizleme
  // kapatilir -> pencere + kapatma (X) tusu %100 native/gorunur olur; chat
  // KAPANINCA launcher tekrar gizlenir. (Kalici gizleme, acik pencerenin X'ini ve
  // konumunu bozuyordu: baloncuk = acikken kapatma tusu.) Eski Inbox launcher'i da
  // gizli tutulur (cift baloncuk olmasin).
  var _hide = document.createElement('style');
  _hide.textContent =
    '.chizy-bubble-container,.chizy-bubble-wrapper,.chizy-bubble-wrapper-v2,' +
    '.chizy-chat-bubble,.chizy-bubble-with-label,.chizy-bubble-custom-icon,' +
    '.chizy-chat-logo-default,' +
    'shopify-chat,#ShopifyChat,shopify-inbox,#ShopifyInbox' +
    '{opacity:0 !important;pointer-events:none !important;}';
  (document.head || document.documentElement).appendChild(_hide);
  _hide.disabled = false; // baslangic: launcher gizli

  function chizy() { return window.ChizyChat || null; }
  function isChizyOpen() { var C = chizy(); return !!(C && C.state && C.state.isOpen); }

  // Chat acik/kapali durumuna gore launcher'i goster/gizle.
  // ACIKKEN gizlemeyi TAMAMEN kaldirir (hicbir chizy elementi gizli degil) ->
  // pencere + X tusu native. Acilip KAPANINCA launcher tekrar gizlenir.
  var _everOpened = false;
  setInterval(function () {
    if (isChizyOpen()) {
      _everOpened = true;
      if (!_hide.disabled) _hide.disabled = true;   // goster
    } else if (_everOpened) {
      if (_hide.disabled) _hide.disabled = false;   // tekrar gizle
      _everOpened = false;
    }
  }, 300);

  // --- Chizy'yi ac (TEK TIKTA) ---
  // Chizy split-stub 2-fazlidir: ilk .open() full chunk'i yukler + init eder ama
  // acmayabilir (init bitmeden). Bu yuzden: hemen ac + init tamamlaninca
  // (state.isInitialized) acilmadiysa TEKRAR ac. Public API: window.ChizyChat
  // (chizy-loader.js: "Theme code may call it directly"). ChizyChat henuz yoksa
  // #chizy-open hash deep-link'i loader tarafindan poll edilerek acilir.
  function reallyOpen() {
    try {
      var C = chizy();
      if (C && typeof C.open === 'function') { C.open(); return true; }
    } catch (e) {}
    return false;
  }
  function openChizy() {
    _hide.disabled = true; // acilis flash'i olmasin diye pesinen goster
    if (!reallyOpen()) {
      try { window.location.hash = 'chizy-open'; } catch (e) {}
    }
    var tries = 0;
    if (window.__tlskChizyOpenPoll) clearInterval(window.__tlskChizyOpenPoll);
    window.__tlskChizyOpenPoll = setInterval(function () {
      tries++;
      var C = chizy();
      if (C && C.state) {
        if (C.state.isOpen) { // acildi
          clearInterval(window.__tlskChizyOpenPoll); window.__tlskChizyOpenPoll = null;
          return;
        }
        if (C.state.isInitialized) reallyOpen(); // init bitti, hala kapali -> tekrar ac
      }
      if (tries > 80) { // ~20s guvenlik siniri
        clearInterval(window.__tlskChizyOpenPoll); window.__tlskChizyOpenPoll = null;
      }
    }, 250);
  }

  // --- Mobil menu drawer'ini kapat (chat acilinca menu/kapatma tusu ustte kalmasin) ---
  // Sadece tetikleyici drawer icindeyse. T4S close = [data-drawer-close] (fallback overlay).
  function closeMobileDrawer(trigger) {
    if (!trigger.closest || !trigger.closest('#t4s-menu-drawer')) return;
    try {
      var btn = document.querySelector('#t4s-menu-drawer [data-drawer-close]');
      if (btn) { btn.click(); return; }
      var ov = document.querySelector('.t4s-close-overlay');
      if (ov) ov.click();
    } catch (e) {}
  }

  // --- Ortak tetikleyici handler (click + touch için) ---
  var _lastTrigger = 0;
  function handleTrigger(e) {
    var trigger = e.target.closest('[data-open-chat]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    // Mobilde tek tap touchend + click uretir -> 600ms debounce (cift acilim engeli)
    var now = Date.now();
    if (now - _lastTrigger < 600) return;
    _lastTrigger = now;

    closeMobileDrawer(trigger);
    openChizy();
  }

  // Desktop + mobil:
  document.addEventListener('click', handleTrigger, { passive: false });
  document.addEventListener('touchend', handleTrigger, { passive: false });

})();

// preload
  document.addEventListener('DOMContentLoaded', function() {
    const preloader = document.getElementById('talishko-preloader');
    if (!preloader) return;

    // 1. GÖREV: Sayfa yüklendiğinde perdeyi kaldır
    window.addEventListener('load', function() {
      preloader.classList.add('preloader-hidden');
    });

    setTimeout(function() {
      preloader.classList.add('preloader-hidden');
    }, 2500);

    // 2. GÖREV: Sadece izin verilen sayfalara tıklandığında perdeyi indir
    const links = document.querySelectorAll('a[href^="/"], a[href^="' + window.location.origin + '"]');
    
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        
        if (e.defaultPrevented) return;

        // Menü, Çekmece ve Popup Engelleyiciler
        if (link.hasAttribute('aria-haspopup') || link.hasAttribute('aria-expanded') || link.hasAttribute('aria-controls') || link.hasAttribute('data-toggle') || link.closest('summary')) {
          return;
        }

        // Standart Engelleyiciler (Sepet, Variant, Yeni Sekme vb.)
        if (link.target === '_blank' || link.href.includes('#') || link.getAttribute('href') === '#' || link.href.includes('javascript:void(0)') || link.href.includes('mailto:') || link.href.includes('tel:') || link.href.includes('?variant=') || e.ctrlKey || e.metaKey || link.hasAttribute('download')) {
          return;
        }

        // --- YENİ EKLENEN KISITLAMA: Gidilen adres izinli listemizde mi? ---
        const href = link.getAttribute('href');
        if (href) {
          const isAllowedPage = href.includes('/products/') ||  
                                href.includes('/policies/');
          
          if (!isAllowedPage) {
            return; // Eğer Ana Sayfaya, Sepete veya Bloga gidiyorsa perdeyi İNDİRME
          }
        }
        
        // Her şey uyuyorsa perdeyi kapat ve yeni sayfanın yüklenmesini bekle
        preloader.classList.remove('preloader-hidden');
      });
    });
  });

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      const preloader = document.getElementById('talishko-preloader');
      if (preloader) preloader.classList.add('preloader-hidden');
    }
  });

  document.addEventListener("DOMContentLoaded", function() {
    // Tarayıcının varsayılan kaydırma (scroll) fonksiyonunu yedekliyoruz
    const originalScrollIntoView = Element.prototype.scrollIntoView;

    // Fonksiyonu yeniden yazıp araya giriyoruz
    Element.prototype.scrollIntoView = function(options) {
      
      // KURAL 1: Ekran genişliği 1025px ve üzeriyse (SADECE PC/MASAÜSTÜ İSE) çalışsın
      if (window.innerWidth >= 1025) {
        
        // KURAL 2: Kaydırılmak istenen öğe 'ilk görsel' ise
        if (this.classList.contains('t4s-product__media-item') && !this.previousElementSibling) {
          
          // Temanın yarım kaydırmasını iptal et ve sayfayı kusursuzca en tepeye kaydır
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return; // İşlemi burada kes, aşağıdaki orijinal kodu çalıştırma
        }
      }
      
      // Eğer kullanıcı MOBİL/TABLET'te ise veya tıklanan şey 2./3. görsel ise:
      // Temanın orijinal işlemini yapmasına hiçbir müdahale etmeden izin ver.
      originalScrollIntoView.call(this, options);
    };
  });

// --- 1. GENEL KAYDIRMA FONKSİYONLARI ---
document.addEventListener('DOMContentLoaded', () => {
    const getHeaderOffset = () => window.innerWidth <= 768 ? 280 : 160;

    const killThemeScroll = () => {
        if (typeof window.jQuery !== 'undefined') {
            window.jQuery('html, body').stop(true, false);
        }
    };

    const openAndScroll = (targetElementId) => {
        const targetEl = document.getElementById(targetElementId);
        if (!targetEl) return;

        const parentTab = targetEl.closest('.t4s-tab-content');
        
        if (parentTab) {
            const tabBtns = document.querySelectorAll(`[data-t4s-tab-item][href="#${parentTab.id}"], [data-t4s-tab-item][data-target="#${parentTab.id}"]`);
            
            let visibleBtn = null;
            for (let btn of tabBtns) {
                if (btn.offsetWidth > 0 || btn.offsetHeight > 0) {
                    visibleBtn = btn;
                    break;
                }
            }

            if (visibleBtn && !visibleBtn.classList.contains('t4s-active')) {
                if (typeof window.jQuery !== 'undefined') {
                    window.jQuery(visibleBtn).trigger('click');
                } else {
                    visibleBtn.click();
                }
                
                setTimeout(killThemeScroll, 10);
                setTimeout(killThemeScroll, 50);
            }
        }

        setTimeout(() => {
            killThemeScroll(); 
            
            const rect = targetEl.getBoundingClientRect();
            if (rect.height > 0 || (parentTab && parentTab.classList.contains('t4s-active'))) {
                const offsetPosition = rect.top + window.scrollY - getHeaderOffset();
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 400); 
    };

    document.addEventListener('click', (e) => {
        const starTrigger = e.target.closest('.loox-rating, a[href="#looxReviews"]');
        if (starTrigger) {
            e.preventDefault();
            e.stopPropagation(); 
            e.stopImmediatePropagation(); 
            
            const reviewId = document.getElementById('talishko-community-report') ? 'talishko-community-report' : 'looxReviews';
            openAndScroll(reviewId);
        }

        const readMoreBtn = e.target.closest('.t4s-product__description_readm');
        if (readMoreBtn) {
            e.preventDefault();
            e.stopPropagation(); 
            e.stopImmediatePropagation(); 
            
            openAndScroll('talishko-full-description');
        }
    }, true); 
});

document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      const bannerItems = document.querySelectorAll('.t4s-banner-inner');
      
      bannerItems.forEach(item => {
        item.addEventListener('mousemove', (e) => {
          const rect = item.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          
          // Merkezden uzaklığa göre hareketi hesapla (Kutu dışına taşmasın diye max 12px)
          const centerX = rect.width / 2;
          const centerY = rect.height / 2;
          const moveX = ((x - centerX) / centerX) * 12; 
          const moveY = ((y - centerY) / centerY) * 12;
          
          item.style.setProperty('--move-x', `${moveX}px`);
          item.style.setProperty('--move-y', `${moveY}px`);
        });

        // Fare çıkınca merkeze yumuşakça dönmesi için sıfırla
        item.addEventListener('mouseleave', () => {
          item.style.setProperty('--move-x', `0px`);
          item.style.setProperty('--move-y', `0px`);
        });
      });
    }
  });


/* TLSK mobile drawer accordion: CATEGORIES = single-open cascade (toggle is--opend + animate max-height, block theme jQuery slide); MENU = keep native, clear jQuery queue to fix rapid-toggle bug */
(function(){
  if (window.__tlskDrawerAccordion) return; window.__tlskDrawerAccordion = 1;
  document.addEventListener('click', function(ev){
    var t = ev.target; if (!t || !t.closest) return;
    var head = t.closest('#menu-mb__cat .tlsk-cat-grp > a');
    if (head){
      ev.preventDefault(); ev.stopImmediatePropagation();
      var li = head.parentElement;
      var ul = li.querySelector(':scope > ul.t4s-sub-menu');
      var willOpen = !li.classList.contains('is--opend');
      var cont = li.parentElement;
      if (cont){
        var sibs = cont.querySelectorAll(':scope > .tlsk-cat-grp.is--opend');
        for (var i=0;i<sibs.length;i++){
          if (sibs[i] !== li){ sibs[i].classList.remove('is--opend'); var su = sibs[i].querySelector(':scope > ul.t4s-sub-menu'); if (su) su.style.maxHeight = '0px'; }
        }
      }
      if (willOpen){ li.classList.add('is--opend'); if (ul) ul.style.maxHeight = ul.scrollHeight + 'px'; }
      else { li.classList.remove('is--opend'); if (ul) ul.style.maxHeight = '0px'; }
      return;
    }
    var micon = t.closest('#menu-mb__ul .t4s-mb-nav__icon');
    if (micon){
      var jq = window.jQuery || window.$;
      if (jq){ var pli = micon.closest('.t4s-menu-item-has-children'); if (pli){ try { jq(pli).children('ul').stop(true, true); } catch (e) {} } }
    }
  }, true);
})();


/* TLSK: index MENU tab sub-menu items (--tlsk-i) so the panel-driven cascade (--tlsk-stg) works there too. Runs on load + when drawer content is injected. */
(function(){
  if (window.__tlskMenuIndex) return; window.__tlskMenuIndex = 1;
  function indexMenu(){
    var ul = document.getElementById('menu-mb__ul'); if (!ul) return;
    var subs = ul.querySelectorAll('.t4s-sub-menu');
    for (var s=0; s<subs.length; s++){
      var kids = subs[s].children, i = 0;
      for (var k=0; k<kids.length; k++){
        var li = kids[k];
        if (li.nodeType === 1 && li.classList.contains('t4s-menu-item')){ li.style.setProperty('--tlsk-i', i); i++; }
      }
    }
  }
  function start(){
    var root = document.getElementById('t4s-menu-drawer') || document.body;
    try {
      var mo = new MutationObserver(function(){ clearTimeout(window.__tlskIdxT); window.__tlskIdxT = setTimeout(indexMenu, 60); });
      mo.observe(root, { childList:true, subtree:true });
    } catch(e){}
    indexMenu();
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();


/* TLSK hover-scrub (design 1 product cards): move mouse across the image to browse product photos. Mouse only; touch keeps native swipe/scroll. Theme image2 hover disabled for style1 in pr-grid-item1. */
(function(){
  if (window.__tlskScrub) return; window.__tlskScrub = 1;
  var CSS = ''
    + '.t4s-product-img .tlsk-scrub-layer{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:4;pointer-events:none;visibility:hidden;background-color:#f1f1f1;}'   // cutout (şeffaf) görsel: opak #f1f1f1 zemin → şeffaf alan koyu yerine kart rengini gösterir; aktif OLMAYAN katman HİÇ boyanmaz
    + '.t4s-product-img .tlsk-scrub-layer.is-on{z-index:6;visibility:visible;}'
    + '.t4s-product-img .tlsk-scrub-layer.is-next{z-index:5;visibility:visible;}'
    + '.t4s-product-img.tlsk-anim .tlsk-scrub-layer{transition:transform .32s cubic-bezier(.22,.61,.36,1);}'
    + '.t4s-pr-style1 .t4s-product-img{overflow:hidden;}'
    + '.t4s-pr-style1.tlsk-built .t4s-product-main-img{visibility:hidden;}'   // galeri kurulunca tema ana resmini gizle → cutout layer'ın şeffaf alanından sızmasın (layer0 zaten aynı 1. foto)
    + '.t4s-product-img .tlsk-scrub-bars{position:absolute!important;top:auto!important;left:8px!important;right:8px!important;bottom:8px!important;width:auto!important;height:auto!important;display:flex;gap:4px;z-index:7;opacity:0;transition:opacity .2s ease;pointer-events:none;}'
    + '.t4s-product.tlsk-scrubbing .tlsk-scrub-bars{opacity:1;}'
    + '.t4s-product-img .tlsk-scrub-bars span{flex:1;height:2px;background:rgba(0,0,0,.6);border-radius:2px;transition:background .15s ease;}'
    + '.t4s-product-img .tlsk-scrub-bars span.is-on{background:#00e08f;}'
    + '.t4s-pr-style1 .t4s-product-img,.t4s-pr-style1 .t4s-full-width-link{touch-action:pan-y;}'
    // Mobil/tablet (touch): tema'nın hover-zoom'unu (pr_img_effect_2 scale 1.09 + 2s transition) Design 1'de KAPAT — tap'te önce yavaş yaklaşma sonra foto değişmesi gecikme yaratıyordu. Sadece dokunmatik; PC hover'da tema efekti aynen kalır.
    + '@media (hover: none){.t4s-pr-style1 .t4s-product-img img{transition:none!important;}.t4s-pr-style1 .t4s-product-inner:hover .t4s-product-main-img,.t4s-pr-style1 .t4s-product-inner:hover .t4s-product-hover-img{transform:none!important;-webkit-transform:none!important;}}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  // PREWARM: kart viewport'a yaklaşınca (600px önceden) galeri fotolarını ağdan çekip decode et → hover'da build() cache'den ANINDA decode eder, 2. foto geçişi de diğerleriyle aynı 900ms ritmine girer. Sadece PC + saveData kapalı; viewport-driven olduğu için tüm kartları aynı anda yüklemez (tıkanma yok).
  var __canHoverDev = false; try { __canHoverDev = matchMedia('(hover: hover)').matches; } catch(e){}
  var __saveData = false; try { __saveData = !!(navigator.connection || {}).saveData; } catch(e){}
  var __pwQ = [], __pwReady = (document.readyState === 'complete');
  if (!__pwReady) window.addEventListener('load', function(){ __pwReady = true; var f = function(){ for (var i=0;i<__pwQ.length;i++) tlskPrewarm(__pwQ[i]); __pwQ = []; }; if (window.requestIdleCallback) requestIdleCallback(f, { timeout: 2500 }); else setTimeout(f, 400); });
  function tlskPrewarm(card){
    if (__saveData || card.__tlskWarm) return;
    if (!__pwReady){ if (__pwQ.indexOf(card) < 0) __pwQ.push(card); return; }        // PERF: load'dan önce prewarm YOK (LCP ile yarışmasın)
    card.__tlskWarm = 1;   // prewarm hem PC hem dokunmatik (gecikmesiz ilk swipe)
    var urls; try { urls = JSON.parse(card.getAttribute('data-tlsk-scrub') || '[]'); } catch(e){ return; }
    if (!urls || urls.length < 2) return;
    var load = function(u){ var im = new Image(); im.decoding = 'async'; im.src = u; if (im.decode) im.decode().catch(function(){}); };
    load(urls[1]);                                                                  // 2. foto önce (en kritik)
    var rest = function(){ for (var i = 2; i < urls.length; i++) load(urls[i]); };
    if (window.requestIdleCallback) requestIdleCallback(rest, { timeout: 3000 }); else setTimeout(rest, 800);
  }
  var __prewarmIO = null;
  try { __prewarmIO = new IntersectionObserver(function(ents){ for (var i = 0; i < ents.length; i++){ if (ents[i].isIntersecting){ tlskPrewarm(ents[i].target); __prewarmIO.unobserve(ents[i].target); } } }, { rootMargin: '600px 0px' }); } catch(e){}
  function suppressClick(){ var sup = function(ev){ ev.stopPropagation(); ev.preventDefault(); document.removeEventListener('click', sup, true); }; document.addEventListener('click', sup, true); setTimeout(function(){ document.removeEventListener('click', sup, true); }, 500); }
  function momentum(el, v){ var last = performance.now(); (function step(now){ var dt = now - last || 16; last = now; el.scrollLeft -= v * dt; v *= Math.pow(0.95, dt / 16); if (Math.abs(v) > 0.02) requestAnimationFrame(step); })(performance.now()); }
  // Başka bir şeyle ilgilenince (sayfa/şerit kaydırma ya da başka karta dokunma) konum çubuklarını gizle
  function tlskClearBars(except){ var on = document.querySelectorAll('.t4s-product.tlsk-scrubbing'); for (var i = 0; i < on.length; i++){ if (on[i] !== except) on[i].classList.remove('tlsk-scrubbing'); } }
  document.addEventListener('touchstart', function(e){ var c = (e.target && e.target.closest) ? e.target.closest('.t4s-pr-style1') : null; tlskClearBars(c); }, { passive:true });
  document.addEventListener('scroll', function(){ tlskClearBars(null); }, { passive:true, capture:true });

  function setup(card){
    if (card.__tlskScrub) return;
    if (card.closest && card.closest('.tlsk-hp-strip')) return;   // Best Sellers strip → tema-native flickity kart slider'ı (__tlskCardSlider) devralır; scrub DEVRE DIŞI
    var inner = card.querySelector('.t4s-product-inner');
    var imgwrap = card.querySelector('.t4s-product-img');
    if (!inner || !imgwrap) return;
    var urls; try { urls = JSON.parse(card.getAttribute('data-tlsk-scrub') || '[]'); } catch(e){ urls = []; }
    if (!urls || urls.length < 2) return;
    card.__tlskScrub = 1;
    // 2. foto geç gelmesin: kartı viewport-yaklaşma gözlemine al (hover'dan önce galeri fotoları ağdan inip decode olur). Eski "tüm kartları anında prewarm" yaklaşımı sayfa yükünde tıkanma yaratıyordu; bu viewport-driven sürüm yükü dağıtır.
    try { if (__prewarmIO) __prewarmIO.observe(card); else tlskPrewarm(card); } catch(e){}
    var built = false, layers = [], bars = [], cur = 0;
    function build(){
      if (built) return; built = true;
      card.classList.add('tlsk-built');   // tema ana resmini gizle (CSS) → cutout layer'lardan sızma olmasın
      var bw = document.createElement('div'); bw.className = 'tlsk-scrub-bars';
      urls.forEach(function(u, i){
        var im = document.createElement('img'); im.className = 'tlsk-scrub-layer' + (i===0?' is-on':''); im.alt=''; im.decoding='async'; im.src = u;
        if (im.decode) { im.decode().catch(function(){}); }   // start decoding now so later photos are ready
        imgwrap.appendChild(im); layers.push(im);
        var b = document.createElement('span'); if (i===0) b.className = 'is-on'; bw.appendChild(b); bars.push(b);
      });
      imgwrap.appendChild(bw);                                                     // absolute → akışta yer kaplamaz, başlık kaymaz
    }
    var showSeq = 0;
    function applyShow(idx){
      cur = idx;
      for (var i=0;i<layers.length;i++){ layers[i].classList.toggle('is-on', i===idx); }
    }
    function show(idx){
      if (idx === cur || !layers[idx]) return;
      for (var i=0;i<bars.length;i++){ bars[i].classList.toggle('is-on', i===idx); }   // move position bar instantly
      var im = layers[idx];
      var seq = ++showSeq;                                                              // ALWAYS wait for full decode (not just 'complete'/loaded) so the base/first image never flashes; keep current photo meanwhile; newest tap wins
      var done = function(){ if (seq === showSeq) applyShow(idx); };
      if (im.decode){ im.decode().then(done).catch(done); }
      else if (im.complete && im.naturalWidth > 0){ done(); }
      else { im.addEventListener('load', done, { once:true }); }
    }
    function isMouse(e){ return !e.pointerType || e.pointerType === 'mouse'; }
    var canHover = false; try { canHover = matchMedia('(hover: hover)').matches; } catch(e){}
    // PC hover: OTOMATIK foto döndürme YOK (kullanıcı istemedi). Sadece manuel scrub: mouse'u resimde yatay gezdirince imleç pozisyonuna göre foto.
    inner.addEventListener('pointerenter', function(e){ if(!isMouse(e) || !canHover) return; build(); card.classList.add('tlsk-scrubbing'); show(0); });
    inner.addEventListener('pointerleave', function(e){ if(!isMouse(e)) return; card.classList.remove('tlsk-scrubbing'); show(0); });
    inner.addEventListener('pointermove', function(e){ if(!isMouse(e) || !canHover || !built) return; var r = imgwrap.getBoundingClientRect(); if(!r.width) return; var idx = Math.floor((e.clientX - r.left) / r.width * urls.length); idx = idx < 0 ? 0 : (idx >= urls.length ? urls.length - 1 : idx); if(idx === cur) return; show(idx); });
    // Mobil/tablet: sağ/sol yarıya TAP → sonraki/önceki foto; orta → ürünü aç. Yatay swipe native kalır (strip kayar). Otomatik dönme YOK.
    var isTouchDev = false; try { isTouchDev = matchMedia('(hover: none)').matches; } catch(e){}
    var flashT; function flashBars(){ card.classList.add('tlsk-scrubbing'); clearTimeout(flashT); flashT = setTimeout(function(){ card.classList.remove('tlsk-scrubbing'); }, 1400); }
    // Mobil/tablet: resim üzerinde yatay sürükle = Instagram tarzı SAYFALI geçiş (parmağı takip eder, eşikte snap, bir sürükleme = bir foto, kenarda direnç). Hızlı flick (yatay strip varsa) = strip kaydır. Dikey = native. Tap → ürünü açar (eski sağ/sol TAP davranışı KALDIRILDI). touch-action:pan-y.
    var hscroll = (function(){ var n = card.parentElement; while (n && n !== document.body){ var s = getComputedStyle(n); if (/(auto|scroll)/.test(s.overflowX) && (n.scrollWidth - n.clientWidth > 8)) return n; n = n.parentElement; } return null; })();
    var SPD = 1.5;
    var pgX, pgY, pgT, pgPX, pgLT, pgV, pgDec, pgMoved, pgW, pgNbr = -1, pgDir = 0;
    function setBars(idx){ for (var i=0;i<bars.length;i++) bars[i].classList.toggle('is-on', i===idx); }
    function setX(layer, x){ layer.style.transform = 'translateX(' + x + 'px)'; }
    function clearNbr(){ if (pgNbr >= 0 && layers[pgNbr]){ layers[pgNbr].classList.remove('is-next'); layers[pgNbr].style.transform = ''; } pgNbr = -1; }
    inner.addEventListener('touchstart', function(e){ if (!isTouchDev || e.touches.length !== 1) return; if (!built) build(); var t = e.touches[0]; pgX = pgPX = t.clientX; pgY = t.clientY; pgT = pgLT = performance.now(); pgV = 0; pgDec = 0; pgMoved = false; }, { passive:true });
    inner.addEventListener('touchmove', function(e){ if (!isTouchDev || e.touches.length !== 1) return;
      var t = e.touches[0], dx = t.clientX - pgX, dy = t.clientY - pgY, now = performance.now();
      var ddx = t.clientX - pgPX, ddt = now - pgLT || 16; pgV = ddx / ddt; pgPX = t.clientX; pgLT = now;
      if (!pgDec){
        var adx0 = Math.abs(dx), ady0 = Math.abs(dy);
        if (adx0 < 10 && ady0 < 10) return;                                                        // deadzone: yön kararı için biraz bekle (erken yanlış karar → scroll çakışması)
        if (ady0 > adx0 * 1.2){ pgDec = 'v'; return; }                                             // belirgin DİKEY → sayfayı native kaydır (foto'ya dokunma)
        // YATAY her zaman foto değişimi olur (parent strip'e DEVRETME YOK). Eski "hızlı flick → strip" davranışı kaldırıldı (kullanıcı isteği: design 1'in hiçbir yerinde kart üstünde swipe parent'i kaydırmasın).
        pgDec = 'page'; if (!built) build(); card.classList.add('tlsk-scrubbing'); imgwrap.classList.remove('tlsk-anim'); var r0 = imgwrap.getBoundingClientRect(); pgW = r0.width || 1;
      }
      if (pgDec === 'page'){
        e.preventDefault(); pgMoved = true;
        var n = urls.length;
        var dir = dx < 0 ? 1 : -1;                                                                 // sola sürükle → sonraki, sağa → önceki
        var nbr = ((cur + dir) % n + n) % n;                                                       // SARMA: 0'dan geri → son foto, son'dan ileri → 0
        if (dir !== pgDir || nbr !== pgNbr){ clearNbr(); pgDir = dir; pgNbr = nbr; layers[pgNbr].classList.add('is-next'); }
        setX(layers[cur], dx);
        setX(layers[pgNbr], (dir === 1 ? pgW : -pgW) + dx);
        setBars(Math.abs(dx) > pgW * 0.5 ? pgNbr : cur);                                           // çubuk resimle senkron: yarıyı geçince komşuya atla
      } else if (pgDec === 'flick' && hscroll){ pgMoved = true; e.preventDefault(); hscroll.scrollLeft -= ddx * SPD; }
    }, { passive:false });
    function pgEnd(){ if (!isTouchDev) return;
      if (pgDec === 'page'){
        var dx = pgPX - pgX;
        var commit = pgNbr >= 0 && (Math.abs(dx) > pgW * 0.18 || Math.abs(pgV) > 0.35) && (pgDir === 1 ? dx < 0 : dx > 0);
        imgwrap.classList.add('tlsk-anim');
        if (commit){
          var from = cur, to = pgNbr;
          setX(layers[from], (pgDir === 1 ? -pgW : pgW)); setX(layers[to], 0);
          var fin = function(){ applyShow(to); layers[from].style.transform = ''; layers[to].classList.remove('is-next'); layers[to].style.transform = ''; imgwrap.classList.remove('tlsk-anim'); setBars(to); pgNbr = -1; pgDir = 0; };
          imgwrap.addEventListener('transitionend', fin, { once:true }); setTimeout(fin, 380);
        } else {
          var nb = pgNbr, c0 = cur;
          setBars(c0);                                                                            // snap-back: çubuğu anında mevcut fotoya geri al
          setX(layers[c0], 0); if (nb >= 0 && layers[nb]) setX(layers[nb], (pgDir === 1 ? pgW : -pgW));
          var fin2 = function(){ if (nb >= 0 && layers[nb]){ layers[nb].classList.remove('is-next'); layers[nb].style.transform = ''; } layers[c0].style.transform = ''; imgwrap.classList.remove('tlsk-anim'); pgNbr = -1; pgDir = 0; };
          imgwrap.addEventListener('transitionend', fin2, { once:true }); setTimeout(fin2, 380);
        }
        flashBars(); if (pgMoved) suppressClick();
      } else if (pgDec === 'flick' && hscroll){ if (pgMoved){ suppressClick(); if (Math.abs(pgV) > 0.15) momentum(hscroll, pgV * SPD); } }
      pgDec = 0; pgMoved = false;
    }
    inner.addEventListener('touchend', pgEnd);
    inner.addEventListener('touchcancel', pgEnd);
  }
  function scan(){ var c = document.querySelectorAll('.t4s-pr-style1[data-tlsk-scrub]'); for (var i=0;i<c.length;i++) setup(c[i]); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  try { var mo = new MutationObserver(function(){ clearTimeout(window.__tlskScrubT); window.__tlskScrubT = setTimeout(scan, 150); }); mo.observe(document.body, { childList:true, subtree:true }); } catch(e){}
})();


/* TLSK: Product recommendations/related "scroll" modu — native akıcı yatay scroll + siyah-yeşil scroll şeridi (Best Sellers gibi). slider_mode=scroll iken liquid flickity'yi kapatır, .tlsk-pscroll bırakır. */
(function(){
  if (window.__tlskRecoScroll) return; window.__tlskRecoScroll = 1;
  var CSS = ''
    + '.t4s-products.tlsk-pscroll{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto;overflow-y:hidden;scrollbar-width:none;-ms-overflow-style:none;cursor:grab;}'
    + '.t4s-products.tlsk-pscroll::-webkit-scrollbar{display:none}'
    + '.t4s-products.tlsk-pscroll.is-grab{cursor:grabbing}'
    + '.t4s-products.tlsk-pscroll>*{flex-shrink:0!important;}'
    + '.tlsk-reco-sbar{position:relative;height:3px;border-radius:99px;background:rgba(0,0,0,.85);margin:18px 0 0;width:100%;cursor:pointer;touch-action:none;}'
    + '.tlsk-reco-sbar__thumb{position:absolute;left:0;top:0;height:100%;width:0;border-radius:99px;background:#00e08f;}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  function build(list){
    if (list.__tlskRS) return; list.__tlskRS = true;
    var bar = document.createElement('div'); bar.className = 'tlsk-reco-sbar';
    var thumb = document.createElement('div'); thumb.className = 'tlsk-reco-sbar__thumb';
    bar.appendChild(thumb); list.insertAdjacentElement('afterend', bar);
    function upd(){ var max = list.scrollWidth - list.clientWidth; if (max <= 2){ bar.style.display='none'; return; } bar.style.display=''; thumb.style.width = ((list.scrollLeft/max)*100)+'%'; }
    function seek(x){ var r = bar.getBoundingClientRect(); var p = Math.min(1, Math.max(0,(x-r.left)/r.width)); list.scrollLeft = p*(list.scrollWidth-list.clientWidth); }
    var drag=false;
    bar.addEventListener('pointerdown', function(e){ drag=true; seek(e.clientX); try{bar.setPointerCapture(e.pointerId);}catch(_){} e.preventDefault(); });
    bar.addEventListener('pointermove', function(e){ if(drag) seek(e.clientX); });
    bar.addEventListener('pointerup', function(){ drag=false; }); bar.addEventListener('pointercancel', function(){ drag=false; });
    list.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd);
    var dn=false,sx=0,ss=0,mv=false;
    list.addEventListener('mousedown', function(e){ if(e.button!==0) return; dn=true; mv=false; sx=e.clientX; ss=list.scrollLeft; });
    document.addEventListener('mousemove', function(e){ if(!dn) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) mv=true; if(mv){ list.scrollLeft=ss-dx; list.classList.add('is-grab'); e.preventDefault(); } });
    document.addEventListener('mouseup', function(){ if(dn){ dn=false; list.classList.remove('is-grab'); } });
    list.addEventListener('click', function(e){ if(mv){ e.preventDefault(); e.stopPropagation(); mv=false; } }, true);
    requestAnimationFrame(upd);
  }
  function scan(root){ (root||document).querySelectorAll('.t4s-products.tlsk-pscroll').forEach(build); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  try { var mo = new MutationObserver(function(){ clearTimeout(window.__tlskRSt); window.__tlskRSt = setTimeout(function(){ scan(); }, 150); }); mo.observe(document.body, { childList:true, subtree:true }); } catch(e){}
})();



/* TLSK: Best Sellers strip — tema-native flickity KART SLİDER'ı (ürün sayfası "Product slider" gibi). data-tlsk-scrub URL'lerinden hücre kurar, window.Flickityt4s ile init eder (aynı tema flickity'si); altta siyah-yeşil noktalar; tap → ürün sayfası (staticClick). Bu kartlarda __tlskScrub DEVRE DIŞI. Koleksiyon grid + öneri kartları eski Instagram-scrub'da kalır. (2026-06-23) */
(function(){
  if (window.__tlskCardSlider) return; window.__tlskCardSlider = 1;
  var CSS = ''
    + '.tlsk-hp-strip .t4s-product-img{position:relative;}'
    + '.tlsk-hp-strip .t4s-card-slider{position:absolute;inset:0;z-index:3;width:100%;height:100%;touch-action:pan-y;}'   // link(z2) üstüne çık → flickity drag çalışsın (butonlar z3 + sonra DOM = tıklanır kalır). touch-action:pan-y → yatay parmak flickity'ye, dikey parmak sayfa scroll'una; strip'in yatay native overflow scroll'u tetiklenmez.
    + '.tlsk-hp-strip .t4s-card-slider .flickityt4s-viewport{height:100%!important;}'
    + '.tlsk-hp-strip .tlsk-cs-cell{width:100%;height:100%;}'
    + '.tlsk-hp-strip .tlsk-cs-cell img{width:100%;height:100%;object-fit:cover;display:block;background:#f1f1f1;}'
    + '.tlsk-hp-strip .t4s-card-slider .flickityt4s-page-dots{position:absolute;bottom:8px;left:8px;right:8px;margin:0;padding:0;display:flex;gap:4px;z-index:5;line-height:0;opacity:0;transition:opacity .25s ease;pointer-events:none;}'   // AUTO-HIDE: default gizli; sadece kart hover'ında veya kullanıcı sürüklerken (flickity is-pointer-down / is-dragging veya JS-driven tlsk-cs-active) görünür
    + '.tlsk-hp-strip .t4s-pr-style1:hover .t4s-card-slider .flickityt4s-page-dots,.tlsk-hp-strip .t4s-card-slider.is-pointer-down .flickityt4s-page-dots,.tlsk-hp-strip .t4s-card-slider.is-dragging .flickityt4s-page-dots,.tlsk-hp-strip .t4s-card-slider.tlsk-cs-active .flickityt4s-page-dots{opacity:1;pointer-events:auto;}'
    + '.tlsk-hp-strip .t4s-card-slider .flickityt4s-page-dots .dot{flex:1;width:auto;height:2px;border-radius:2px;background:rgba(0,0,0,.6);margin:0;opacity:1;transition:background .15s;}'
    + '.tlsk-hp-strip .t4s-card-slider .flickityt4s-page-dots .dot.is-selected{background:#00e08f;}';
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  function setup(card){
    if (card.__tlskCS) return;
    if (typeof window.Flickityt4s !== 'function') return;
    var imgwrap = card.querySelector('.t4s-product-img');
    if (!imgwrap) return;
    var urls; try { urls = JSON.parse(card.getAttribute('data-tlsk-scrub') || '[]'); } catch(e){ return; }
    if (!urls || urls.length < 2) return;
    card.__tlskCS = 1;
    var linkEl = card.querySelector('.t4s-full-width-link');
    var href = linkEl ? linkEl.getAttribute('href') : null;
    var slider = document.createElement('div'); slider.className = 't4s-card-slider';
    var cellImgs = [], hydrated = 1;                                             // PERF: yükte yalnız foto0 (temanınkiyle aynı, cache'te); kalan src'ler etkileşimde
    urls.forEach(function(u, ci){ var c = document.createElement('div'); c.className = 'tlsk-cs-cell'; var im = document.createElement('img'); im.alt = ''; im.decoding = 'async'; if (ci === 0) im.src = u; else im.setAttribute('data-tlsk-src', u); c.appendChild(im); cellImgs.push(im); slider.appendChild(c); });
    function hydrate(upto){ var n = (upto == null || upto === -1) ? cellImgs.length : Math.min(upto, cellImgs.length); for (var i = hydrated; i < n; i++){ var im2 = cellImgs[i], u2 = im2.getAttribute('data-tlsk-src'); if (u2){ im2.src = u2; im2.removeAttribute('data-tlsk-src'); if (im2.decode) im2.decode().catch(function(){}); } } if (n > hydrated) hydrated = n; }
    var main = imgwrap.querySelector('.t4s-product-main-img'); if (main) main.style.visibility = 'hidden';   // cutout sızmasın
    imgwrap.appendChild(slider);
    var fl;
    try {
      fl = new window.Flickityt4s(slider, { cellSelector:'.tlsk-cs-cell', wrapAround:true, pageDots:true, prevNextButtons:false, contain:true, cellAlign:'left', percentPosition:true, dragThreshold:10, adaptiveHeight:false, imagesLoaded:true, watchCSS:false, accessibility:false });
    } catch(e){ if (main) main.style.visibility = ''; slider.remove(); card.__tlskCS = 0; return; }
    if (href) fl.on('staticClick', function(){ window.location.href = href; });   // tap → ürün sayfası (drag = foto değiştir)
    hydrate(2);                                                                    // komşu foto hazır olsun (tek ekstra istek, load sonrası + viewport'a yakın kartta)
    var hydrateAll = function(){ hydrate(-1); };
    fl.on('pointerDown', hydrateAll); fl.on('dragStart', hydrateAll); fl.on('change', hydrateAll);
    slider.addEventListener('touchstart', hydrateAll, { passive:true });
    slider.addEventListener('pointerenter', function(e){ if (!e.pointerType || e.pointerType === 'mouse') hydrateAll(); });
    var __dotsT;
    function dotsShow(){ slider.classList.add('tlsk-cs-active'); clearTimeout(__dotsT); }
    function dotsHideNow(){ clearTimeout(__dotsT); __dotsT = setTimeout(function(){ slider.classList.remove('tlsk-cs-active'); }, 200); }   /* koleksiyon scrub bars gibi: pointer'dan ayrılınca neredeyse anında gizle */
    fl.on('pointerDown', dotsShow);
    fl.on('dragStart', dotsShow);
    fl.on('pointerUp', dotsHideNow);
    fl.on('dragEnd', dotsHideNow);
    var canHover = false; try { canHover = matchMedia('(hover: hover)').matches; } catch(e){}
    if (canHover) {                                                                // PC: mouse'u resimde gezdir → imleç pozisyonuna göre foto (tutup sürüklemeye gerek yok; eski scrub gibi). Drag yine touch için açık.
      slider.addEventListener('pointermove', function(e){ if (e.pointerType && e.pointerType !== 'mouse') return; if (fl.isPointerDown) return; var r = slider.getBoundingClientRect(); if (!r.width) return; var idx = Math.floor((e.clientX - r.left) / r.width * urls.length); idx = idx < 0 ? 0 : (idx >= urls.length ? urls.length - 1 : idx); if (idx !== fl.selectedIndex) fl.select(idx, false, true); });
      slider.addEventListener('pointerleave', function(e){ if (e.pointerType && e.pointerType !== 'mouse') return; fl.select(0, false, true); });
    }
  }

  var __csIO = null;
  try { __csIO = new IntersectionObserver(function(ents){ for (var i = 0; i < ents.length; i++){ if (!ents[i].isIntersecting) continue; var el = ents[i].target; __csIO.unobserve(el); setup(el); if (!el.__tlskCS){ el.__tlskCSq = 0; (function(e2){ setTimeout(function(){ enroll(e2); }, 800); })(el); } } }, { rootMargin: '300px 0px' }); } catch(e){}
  function enroll(card){ if (card.__tlskCSq || card.__tlskCS) return; card.__tlskCSq = 1; if (__csIO) __csIO.observe(card); else setup(card); }
  var __csReady = (document.readyState === 'complete'), __csPend = [];
  if (!__csReady) window.addEventListener('load', function(){ __csReady = true; var f = function(){ for (var i=0;i<__csPend.length;i++) enroll(__csPend[i]); __csPend = []; }; if (window.requestIdleCallback) requestIdleCallback(f, { timeout: 2500 }); else setTimeout(f, 400); });
  function scan(){ var c = document.querySelectorAll('.tlsk-hp-strip .t4s-pr-style1[data-tlsk-scrub]'); for (var i = 0; i < c.length; i++){ if (__csReady) enroll(c[i]); else if (__csPend.indexOf(c[i]) < 0) __csPend.push(c[i]); } }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  try { var mo = new MutationObserver(function(){ clearTimeout(window.__tlskCSt); window.__tlskCSt = setTimeout(scan, 200); }); mo.observe(document.body, { childList:true, subtree:true }); } catch(e){}
})();


/* TLSK — fix iOS/Safari bfcache "broken image (?)" on collection back-navigation.
   On touch the scrub gallery builds JS <img> layers and hides the theme main image;
   the back-forward cache can drop those decoded bitmaps -> broken-image icon. On restore
   (and on any late image error), force-reload the affected photos so they reappear. */
(function(){
  if (window.__tlskBFCacheFix) return; window.__tlskBFCacheFix = 1;
  function reload(im){
    try {
      var ss = im.getAttribute('srcset');
      if (ss){ im.srcset = ''; im.srcset = ss; }
      else { var s = im.getAttribute('src'); if (s){ im.src = ''; im.src = s; } }
    } catch(e){}
  }
  function fixBroken(){
    var ims = document.querySelectorAll('.tlsk-scrub-layer, .t4s-product-main-img, img.lazyloadt4s');
    for (var i = 0; i < ims.length; i++){
      var im = ims[i];
      if (im.complete && im.naturalWidth === 0) reload(im);
    }
  }
  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;     // only when restored from the back-forward cache
    fixBroken();
    setTimeout(fixBroken, 80);
    setTimeout(fixBroken, 300);
  });
  // safety net: retry once any product image that errors out (capture phase — error doesn't bubble)
  document.addEventListener('error', function(e){
    var im = e.target;
    if (!im || im.tagName !== 'IMG' || im.__tlskRetried) return;
    if (im.classList.contains('tlsk-scrub-layer') || im.classList.contains('t4s-product-main-img') || im.classList.contains('lazyloadt4s')){
      im.__tlskRetried = 1; reload(im);
    }
  }, true);
})();


/* ===== TLSK ürün-kodu araması (TAL####) — tek sonuç + aynı kategori önerisi =====
   Sorun: "TAL2055" tokenize edilince "TAL" parçası HER üründe eşleşir
   (marka adı TALISHKO, her SKU öneki TAL####, her açıklama kodu) -> tüm katalog çıkar.
   Çözüm: kod sorgusu çift tırnağa alınır ("TAL2055") -> Shopify tam-öbek eşleşmesi -> TEK ürün.
   Ek: bulunan ürünün product_type'ından aynı kategoriden öneri şeridi + o kategorinin
   koleksiyon sayfasına "View all" linki. Müşteri metni İNGİLİZCE.
   Hem canlı arama (predictive dropdown) hem /search sonuç sayfasında çalışır.
   Sadece bir katman; silinince tema stok davranışına döner. */
(function () {
  if (window.__tlskCodeSearch) return; window.__tlskCodeSearch = 1;

  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* --- kod tespiti --- */
  function normCode(term) {
    var m = String(term || '').replace(/^#/, '').replace(/\s+/g, '').match(/^tal(\d+)$/i);
    return m ? 'TAL' + m[1] : null;
  }
  function stripType(t) { return String(t || '').replace(/^\s*product_type:.*?\bAND\b\s*/i, ''); }
  function quoteQuery(t) {
    var c = normCode(stripType(t));
    if (c) return String(t).replace(stripType(t), '"' + c + '"');
    return String(t).replace(/(^|\s)(tal\d+)(?=\s|$)/gi, function (_, a, code) { return a + '"' + code.toUpperCase() + '"'; });
  }

  /* --- suggest.json --- */
  function suggest(q, fields, limit) {
    var u = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + (limit || 10) +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=' + encodeURIComponent(fields);
    return fetch(u, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
      .catch(function () { return []; });
  }
  var _cache = {};
  function sameCategory(code) {
    if (code in _cache) return Promise.resolve(_cache[code]);
    return suggest('"' + code + '"', 'tag,variants.sku,title,body', 1).then(function (ps) {
      if (!ps.length) { _cache[code] = null; return null; }
      var exact = ps[0], type = exact.type || '';
      if (!type) { var r0 = { exact: exact, type: '', items: [] }; _cache[code] = r0; return r0; }
      return suggest(type, 'product_type', 14).then(function (list) {
        list = list.filter(function (p) { return p.id !== exact.id; }).slice(0, 12);
        var r = { exact: exact, type: type, items: list };
        _cache[code] = r; return r;
      });
    }).catch(function () { return null; });
  }

  /* --- product_type -> koleksiyon çözümleme (/collections.json, bir kez) --- */
  var _cols = null;
  function loadCols() {
    if (_cols) return _cols;
    _cols = fetch('/collections.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var byTitle = {}, byHandle = {};
        (d.collections || []).forEach(function (c) { byTitle[(c.title || '').toLowerCase()] = c.handle; byHandle[c.handle] = 1; });
        return { byTitle: byTitle, byHandle: byHandle };
      }).catch(function () { return { byTitle: {}, byHandle: {} }; });
    return _cols;
  }
  function resolveCollection(type) {
    if (!type) return Promise.resolve(null);
    return loadCols().then(function (m) {
      var t = type.toLowerCase();
      if (m.byTitle[t]) return m.byTitle[t];
      var s = slug(type);
      if (m.byHandle[s]) return s;
      if (m.byHandle[s + 's']) return s + 's';
      if (s.slice(-1) === 's' && m.byHandle[s.slice(0, -1)]) return s.slice(0, -1);
      return null;
    });
  }

  /* --- render --- */
  function money(v) {
    if (v == null) return '';
    if (typeof v === 'string' && /[^\d.]/.test(v)) return v;
    return '$' + String(v);
  }
  function cardHtml(p) {
    var img = p.image || (p.featured_image && p.featured_image.url) || '';
    return '<a class="tlsk-cs__card" href="' + esc(p.url) + '">' +
      (img ? '<span class="tlsk-cs__img"><img loading="lazy" src="' + esc(img) + '" alt=""></span>' : '') +
      '<span class="tlsk-cs__tt">' + esc(p.title) + '</span>' +
      '<span class="tlsk-cs__pr">' + money(p.price) + '</span></a>';
  }
  function hideHolder(h) { if (!h) return; h.style.display = 'none'; h.innerHTML = ''; h.removeAttribute('data-code'); }
  function fill(holder, code) {
    if (!holder) return;
    holder.setAttribute('data-code', code);
    sameCategory(code).then(function (res) {
      if (holder.getAttribute('data-code') !== code) return;
      if (!res || !res.items || !res.items.length) { hideHolder(holder); return; }
      resolveCollection(res.type).then(function (handle) {
        if (holder.getAttribute('data-code') !== code) return;
        var head = '<div class="tlsk-cs__head">' +
          '<span class="tlsk-cs__lbl">More in</span>' +
          (res.type ? '<em class="tlsk-cs__type">' + esc(res.type) + '</em>' : '') +
          (handle ? '<a class="tlsk-cs__all" href="/collections/' + esc(handle) + '">View all</a>' : '') +
          '</div>';
        holder.innerHTML = head + '<div class="tlsk-cs__row">' + res.items.map(cardHtml).join('') + '</div>';
        holder.style.display = '';
      });
    });
  }

  /* --- 1) FORM SUBMIT: /search'e giden q'yu tırnakla -> sonuç sayfası tek ürün --- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var qi = form.querySelector('input[name="q"]');
    if (!qi) return;
    var nq = quoteQuery(qi.value);
    if (nq !== qi.value) qi.value = nq;
  }, true);

  /* --- 2) PREDICTIVE DROPDOWN: kod sorgusunu tırnakla + aynı-kategori şeridi --- */
  function patchInst(el) {
    var inst = el.predictiveSearch;
    if (!inst || inst.__tlsk) return;
    inst.__tlsk = 1;
    var results = el.querySelector('[data-results-search]');
    var input = el.querySelector('[data-input-search]');
    var holder = document.createElement('div');
    holder.className = 'tlsk-cat-suggest';
    holder.style.display = 'none';
    if (results && results.parentNode) results.parentNode.insertBefore(holder, results.nextSibling);
    else el.appendChild(holder);

    // Shopify'a giden sorguyu tırnakla (tek sonuç). Tema kendi render'ıyla gösterir.
    var orig = inst.getSearchResults.bind(inst);
    inst.getSearchResults = function (t) { return orig(quoteQuery(t)); };

    // Aynı-kategori şeridi doğrudan input'tan yönetilir -> boşaltınca (tema kutusu boş) gizlenir,
    // tema varsayılan önerileri geri gelir. (getSearchResults boş sorguda çağrılmadığı için şart.)
    var ev = debounce(function () {
      var code = input ? normCode(stripType(input.value)) : null;
      if (code) fill(holder, code); else hideHolder(holder);
    }, 250);
    if (input) { input.addEventListener('input', ev); input.addEventListener('focus', ev); }
  }
  function scanInst() {
    var els = document.querySelectorAll('[data-predictive-search]');
    for (var i = 0; i < els.length; i++) if (els[i].predictiveSearch) patchInst(els[i]);
  }
  var _t = setInterval(scanInst, 300);
  setTimeout(function () { clearInterval(_t); }, 20000);
  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-predictive-search]')) scanInst();
  }, true);

  /* --- 3) SONUÇ SAYFASI (/search): kod ise aynı-kategori şeridi ekle --- */
  function initPage() {
    try {
      if (location.pathname.indexOf('/search') !== 0) return;
      var qs = new URLSearchParams(location.search);
      var raw = (qs.get('q') || '').replace(/^"|"$/g, '');
      var code = normCode(raw);
      if (!code) return;
      var sec = document.querySelector('.t4s-search-page') || document;
      var grid = sec.querySelector('.t4s-products');
      if (!grid || grid.__tlskCat) return;
      grid.__tlskCat = 1;
      var holder = document.createElement('div');
      holder.className = 'tlsk-cat-suggest tlsk-cat-suggest--page';
      holder.style.display = 'none';
      grid.parentNode.insertBefore(holder, grid.nextSibling);
      fill(holder, code);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage);
  else initPage();

  /* --- scoped stil (geçici, "görünür" fazında elden geçecek) --- */
  var css =
    '.tlsk-cat-suggest{padding:14px 4px 4px}' +
    '.tlsk-cs__head{display:flex;align-items:center;gap:8px;margin:0 8px 10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;font-size:12px;color:#040404}' +
    '.tlsk-cs__type{font-style:normal;font-weight:600;color:#00b67a;letter-spacing:.04em}' +
    '.tlsk-cs__all{margin-left:auto;font-size:11px;font-weight:800;letter-spacing:.08em;color:#040404;text-decoration:none;border-bottom:2px solid #00e08f;padding-bottom:1px}' +
    '.tlsk-cs__all:hover{color:#00b67a}' +
    '.tlsk-cs__row{display:flex;gap:12px;overflow-x:auto;padding:2px 8px 10px;scrollbar-width:thin}' +
    '.tlsk-cs__row::-webkit-scrollbar{height:4px}' +
    '.tlsk-cs__row::-webkit-scrollbar-thumb{background:#00e08f;border-radius:4px}' +
    '.tlsk-cs__card{flex:0 0 128px;width:128px;text-decoration:none;color:#040404}' +
    '.tlsk-cs__img{display:block;aspect-ratio:.8;background:#f1f1f1;border-radius:6px;overflow:hidden;margin-bottom:6px}' +
    '.tlsk-cs__img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.tlsk-cs__tt{display:block;font-size:11px;line-height:1.3;font-weight:600;max-height:2.6em;overflow:hidden}' +
    '.tlsk-cs__pr{display:block;font-size:12px;font-weight:800;margin-top:3px}' +
    '.tlsk-cat-suggest--page{max-width:1200px;margin:26px auto 0;border-top:1px solid #e8e8e8;padding-top:20px}' +
    '.tlsk-cat-suggest--page .tlsk-cs__card{flex-basis:150px;width:150px}';
  var st = document.createElement('style'); st.setAttribute('data-tlsk', 'code-search'); st.textContent = css;
  document.head.appendChild(st);
})();


/* ===== TLSK VEIL RISE — boş-durum içeriği (2026-07-10, admin-ayarlı) =======
   İçerik artık Theme settings > Search'ten gelir (search-hidden.liquid,
   <script data-tlsk-search-config> JSON'u). Ayar yoksa aşağıdaki D varsayılanları.
   Kategoriler admin'den seçilince fetch YOK (liquid handle+görsel verir); seçili
   değilse D.cats + /collections.json fallback. Bento panel AÇILINCA doldurulur
   (mobilde autofocus yok). Görünüm veil.css. Temaya sadece config script eklendi.
   ==========================================================================*/
(function () {
  if (window.__tlskSearchIntro) return; window.__tlskSearchIntro = 1;

  var D = {
    eyebrow:"Search", heading:"Find your fit",
    hint:"Know the model code? Type it to go straight to the piece, e.g. ",
    hintCode:"TAL2055",
    cats:[ ["Pants","Pants"], ["Hoodies","Hoodies"], ["Jeans","Jeans"], ["Jackets","Jackets"] ],
    trending:["Barrel pants","Cargo","Sherpa","Graphic tee","Baggy jeans"]
  };
  var SVG_SEARCH = '<svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>';
  var SVG_TAG = '<svg viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18"></path></svg>';

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function slug(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }

  function readCfg(panel){
    // SADECE theme.liquid'teki global config (benzersiz id). Panel'in sessionStorage'a
    // cache'lenmiş ESKİ (id'siz) config'ini yok say → ayar değişikliği anında yansır.
    var el = document.getElementById('tlsk-search-cfg');
    if (!el) el = document.querySelector('[data-tlsk-search-config]');   // fallback
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch(e){ return {}; }
  }
  function pick(v, d){ return (v == null || v === '') ? d : v; }
  function trendingList(cfg){
    if (cfg && typeof cfg.trending === 'string'){
      return cfg.trending.split(/[\n,]+/).map(function(s){return s.trim();}).filter(Boolean);
    }
    return D.trending;
  }

  /* --- fallback (admin kategori seçmemişse) --- */
  var _cols = null;
  function loadCols(){
    if (_cols) return _cols;
    _cols = fetch('/collections.json?limit=250',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(d){ var bt={},bh={}; (d.collections||[]).forEach(function(c){ var img=c.image&&(c.image.src||c.image.url)||''; bt[(c.title||'').toLowerCase()]={handle:c.handle,img:img}; bh[c.handle]={handle:c.handle,img:img}; }); return {byTitle:bt,byHandle:bh}; })
      .catch(function(){ return {byTitle:{},byHandle:{}}; });
    return _cols;
  }
  function resolveCat(title, m){
    var t=title.toLowerCase(); if (m.byTitle[t]) return m.byTitle[t];
    var s=slug(title); if (m.byHandle[s]) return m.byHandle[s];
    if (m.byHandle[s+'s']) return m.byHandle[s+'s'];
    if (s.slice(-1)==='s' && m.byHandle[s.slice(0,-1)]) return m.byHandle[s.slice(0,-1)];
    return null;
  }
  function catEl(label, url, img, i){                                             // DOM ile kur; arka planı JS'le set (escape sorunu yok)
    var a = document.createElement('a'); a.className = 'tlsk-cat'; a.href = url;
    if (img){ var im = document.createElement('span'); im.className = 'tlsk-cat-img'; im.style.backgroundImage = "url('" + img + "')"; a.appendChild(im); }
    var b = document.createElement('b'); b.textContent = ('0'+(i+1)).slice(-2); a.appendChild(b);
    var s = document.createElement('span'); s.textContent = label; a.appendChild(s);
    return a;
  }
  function renderCats(catsEl, cfg){
    if (!catsEl || catsEl.__done) return; catsEl.__done = 1;
    if (cfg && cfg.cats && cfg.cats.length){                                       // admin seçti -> fetch yok
      cfg.cats.forEach(function(c,i){ catsEl.appendChild(catEl(c.label, c.url, c.img, i)); });
      return;
    }
    loadCols().then(function(m){                                                   // fallback: varsayılan kategoriler
      D.cats.forEach(function(pair,i){ var c=resolveCat(pair[0],m); if(!c) return;
        catsEl.appendChild(catEl(pair[1], '/collections/'+c.handle, c.img, i)); });
    });
  }

  function buildHead(cfg){
    var h = document.createElement('div'); h.className='tlsk-search-head';
    h.innerHTML = '<div class="tlsk-eyebrow">'+esc(pick(cfg.eyebrow,D.eyebrow))+'</div><h2>'+esc(pick(cfg.heading,D.heading))+'</h2>';
    return h;
  }
  function buildIntro(cfg){
    var wrap = document.createElement('div'); wrap.className='tlsk-search-intro';
    var lead = pick(cfg.hint, D.hint), code = pick(cfg.hintCode, D.hintCode);
    var hintHtml = (lead || code)
      ? '<div class="tlsk-intro-hint">'+SVG_TAG+'<span>'+esc(lead)+(code?'<b>'+esc(code)+'</b>':'')+'</span></div>' : '';
    var tr = trendingList(cfg);
    var trendHtml = tr.length
      ? '<div class="tlsk-intro-block"><div class="tlsk-intro-head">Trending</div><div class="tlsk-trend">'+
        tr.map(function(t){ return '<a href="/search?q='+encodeURIComponent(t)+'&type=product&options%5Bprefix%5D=last">'+esc(t)+'</a>'; }).join('')+
        '</div></div>' : '';
    wrap.innerHTML = hintHtml +
      '<div class="tlsk-intro-block"><div class="tlsk-intro-head">Browse</div><div class="tlsk-cats"></div></div>' +
      trendHtml;
    return wrap;
  }

  function setup(panel){
    if (panel.__tlskIntro) return;
    var form = panel.querySelector('form.t4s-mini-search__frm, [data-frm-search]');
    var input = panel.querySelector('[data-input-search]');
    var inner = panel.querySelector('.t4s-mini-search__inner');
    if (!form || !input) return;
    panel.__tlskIntro = 1;
    var cfg = readCfg(panel);

    if (inner && !inner.querySelector('.tlsk-si')) {
      var si = document.createElement('span'); si.className='tlsk-si'; si.innerHTML=SVG_SEARCH;
      inner.insertBefore(si, inner.firstChild);
    }
    if (!panel.querySelector('.tlsk-search-head')) form.parentNode.insertBefore(buildHead(cfg), form);
    if (!panel.querySelector('.tlsk-search-intro')) form.parentNode.insertBefore(buildIntro(cfg), form.nextSibling);

    function sync(){ panel.classList.toggle('tlsk-empty', !input.value.trim()); }
    function fillNow(){ renderCats(panel.querySelector('.tlsk-cats'), cfg); }
    input.addEventListener('input', sync);
    input.addEventListener('focus', function(){ sync(); fillNow(); });
    try {
      new MutationObserver(function(){ if (panel.getAttribute('aria-hidden') === 'false') fillNow(); })
        .observe(panel, { attributes:true, attributeFilter:['aria-hidden'] });
    } catch(e){}
    if (panel.getAttribute('aria-hidden') === 'false') fillNow();
    sync();
  }
  function scan(){ document.querySelectorAll('#t4s-search-hidden, [data-predictive-search]').forEach(setup); }
  var t = setInterval(scan, 400);
  setTimeout(function(){ clearInterval(t); }, 20000);
  document.addEventListener('focusin', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-predictive-search]')) scan();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();


/* ===== TLSK VEIL RISE — premium sonuç barı (2026-07-09, loop-safe) =========
   Tema title + view-all'ı üst bara taşır, ürün sayacı + kod aramasında tek
   sonuca "Exact match" rozeti. DONMA FIX: observer yalnız `results`in DOĞRUDAN
   çocuklarını izler (subtree YOK) -> derin rozet eklemem observer'ı tetiklemez;
   ayrıca refresh sırasında guard bayrağı. Tema elemanları taşınır (silinmez).
   ==========================================================================*/
(function () {
  if (window.__tlskResultsBar) return; window.__tlskResultsBar = 1;
  function codeOf(s){ var m=String(s||'').replace(/^#/,'').replace(/\s+/g,'').match(/^tal(\d+)$/i); return m?'TAL'+m[1]:null; }

  function setup(panel){
    if (panel.__tlskRB) return;
    var title   = panel.querySelector('[data-title-search]');
    var content = panel.querySelector('.t4s-drawer__content');
    var results = panel.querySelector('[data-results-search]');
    var input   = panel.querySelector('[data-input-search]');
    var viewall = panel.querySelector('[data-viewAll-search]');
    if (!title || !content || !results) return;
    panel.__tlskRB = 1;

    var bar = document.createElement('div'); bar.className = 'tlsk-resbar';
    content.parentNode.insertBefore(bar, content);
    bar.appendChild(title);
    if (viewall) bar.appendChild(viewall);
    var cnt = document.createElement('span'); cnt.className = 'tlsk-rescount';
    title.appendChild(cnt);

    var busy = false;
    function refresh(){
      if (busy) return; busy = true;
      try {
        var cards = results.querySelectorAll('.t4s-widget__pr');
        var n = cards.length;
        cnt.textContent = n ? ('· ' + n + (n === 1 ? ' item' : ' items')) : '';
        var code = input && codeOf(input.value);
        for (var i=0;i<cards.length;i++){ var old = cards[i].querySelector('.tlsk-exact'); if (old) old.remove(); }
        if (code && n === 1){
          var img = cards[0].querySelector('.t4s-widget_img_pr');
          if (img){ var e = document.createElement('span'); e.className='tlsk-exact'; e.textContent='Exact match'; img.appendChild(e); }
        }
      } catch(err){}
      busy = false;
    }
    // yalnız doğrudan childList (tema results.innerHTML'i değiştirince) -> loop yok
    try { new MutationObserver(refresh).observe(results, { childList:true }); } catch(e){}
    refresh();
  }
  function scan(){ document.querySelectorAll('#t4s-search-hidden, [data-predictive-search]').forEach(setup); }
  var t = setInterval(scan, 400);
  setTimeout(function(){ clearInterval(t); }, 20000);
  document.addEventListener('focusin', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-predictive-search]')) scan();
  }, true);
})();

